import { initialState } from "store/Filters/initialState";
import * as filters from "store/Filters/constants";
import { PAPERWORK_TYPE, PAPERWORK_STATE } from "store/PaperWork/constants";

export const FILTER_CERTIFICATES_TABLE = { 
    ...initialState,
    [filters.FILTER_TYPES]: [PAPERWORK_TYPE.D1, PAPERWORK_TYPE.D2],
    [filters.FILTER_STATUS]: [PAPERWORK_STATE.APPROVE_REQUESTED, PAPERWORK_STATE.APPROVED, PAPERWORK_STATE.OBSERVED, PAPERWORK_STATE.REJECTED, PAPERWORK_STATE.REJECT_REQUESTED],
};